// extracted by mini-css-extract-plugin
export var aircallIframe = "_m6-3";
export var fabContainer = "_m6-5";
export var fabRinging = "_m6-6";
export var loadingOverlay = "_m6-4";
export var pulse = "_m6-7";
export var widgetContent = "_m6-2";
export var widgetPanel = "_m6-0";
export var widgetPanelExpanded = "_m6-1";